export const getWorkItem = (str) => {
	// get from the last '[[' to the end of the string
	const slice = str.slice(str.lastIndexOf('[[') + 2);

	// get up to the first ']]'
	return slice.substring(0, slice.indexOf(']]'));
};

export const containsSingleWorkItem = (str) =>
	str.indexOf('[[') !== -1 && str.indexOf('[[') === str.lastIndexOf('[[');

export const containsOnlyASingleWorkItem = (str) =>
	containsSingleWorkItem(str) &&
	str.indexOf('[[') === 0 &&
	str.indexOf(']]') === str.length - 2;

export const containsWorkItem = (str) =>
	str.includes('[[') && str.includes(']]');
